import { SectionHelpTooltip } from "@/components/shared/SectionHelpTooltip";
import { Button } from "@/components/ui/button";
import { chromeSelectClass } from "@/lib/map-chrome";
import { cn } from "@/lib/utils";
import type { VisualizerLegendEntry } from "@/services/visualizer.service";
import { List } from "lucide-react";

type VisualizerLegendToggleProps = {
  open: boolean;
  onToggle: () => void;
  entries: VisualizerLegendEntry[];
};

export function VisualizerLegendToggle({ open, onToggle, entries }: VisualizerLegendToggleProps) {
  return (
    <div
      className={cn(
        /* bottom-14: выше ScaleControl (bottom-left), без перекрытия шкалы */
        "pointer-events-auto absolute bottom-14 left-3 z-[110] flex flex-col gap-1",
        chromeSelectClass,
      )}
    >
      {open && (
        <div className="mb-1 max-h-56 w-64 overflow-y-auto rounded-md border bg-card/95 p-2 text-sm shadow-md backdrop-blur">
          <div className="mb-1 flex items-center gap-1">
            <span className="font-medium">Легенда</span>
            <SectionHelpTooltip label="Справка: легенда сцены">
              <p>Одинаковый знак одного вида схлопывается в строку. Точка и линия одного знака — две строки.</p>
            </SectionHelpTooltip>
          </div>
          {entries.length === 0 ? (
            <p className="text-xs text-muted-foreground">Пусто</p>
          ) : (
            <ul className="space-y-1">
              {entries.map((entry) => (
                <li key={entry.key} className="flex items-center justify-between gap-2">
                  <span className="truncate">{entry.name}</span>
                  <span className="text-muted-foreground">{entry.count}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
      <Button
        type="button"
        size="sm"
        variant={open ? "default" : "secondary"}
        onClick={onToggle}
        className="gap-1.5"
        aria-label={open ? "Скрыть легенду" : "Добавить легенду"}
      >
        <List className="h-4 w-4 shrink-0" aria-hidden />
        {open ? "Скрыть легенду" : "Добавить легенду"}
      </Button>
    </div>
  );
}
